import './common.common';

// Fix viewport height units (vh)
import './helpers/viewport-height-fix';

// Toolbar extended
import toolbar from './features/toolbar';

toolbar('.js-toolbar');
